import React from 'react'
import { Fade, CircularProgress } from '@mui/material'

// The one spinner style used everywhere something is loading -- the
// whole-app auth check (LoadingScreen) and a page's stikis (TopMenu) both
// use this, rather than each picking its own size/colour.
export default function LoadingSpinner() {
  return (
    <Fade in timeout={5000}>
      <CircularProgress size={80} thickness={3} sx={{ color: 'grey.500' }} />
    </Fade>
  )
}
